// extracted by mini-css-extract-plugin
module.exports = {"main":"HowItWorksBtn_main__AK_HP","responsive":"HowItWorksBtn_responsive__42v1m"};